import cn from 'classnames';

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';

interface Props {
  freshInvestigation?: boolean;
  slug?: string;
  description?: string;
  buttonTitle?: string;
  className?: string;
}

export const EmptyBlock = ({ freshInvestigation, description, buttonTitle, slug, className = '' }: Props) => {
  const { t } = useInt();

  return (
    <div className={cn('empty-block', className)}>
      {freshInvestigation ? (
        <div className="fresh-investigation-wrapper">
          <span>{description}</span>

          <Button type="invert" size="xl" route={slug}>
            {buttonTitle}
          </Button>
        </div>
      ) : (
        <div className="fresh-investigation-wrapper">
          <span>{t('Not Found')}</span>
        </div>
      )}
    </div>
  );
};
